document.addEventListener('DOMContentLoaded', () => {
  const collRevSwiper = new Swiper('.cstm-coll-reviews-swiper', {
    slidesPerView: 1.4,
    spaceBetween: 15,
    breakpoints: {
      1000: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
    },
    navigation: {
      nextEl: '.coll-rev-swiper-button-next',
      prevEl: '.coll-rev-swiper-button-prev',
    },
  });
});